import User from "@Shared/Entities/AbstractEntities/User";
import { UserType } from "@Shared/Entities/AbstractEntities/User/enums";
import constraints from "./constraints";
import migrate from "./migrate";
export default class SupplierUser extends User {
    constructor(data = {}) {
        super(migrate(data), constraints);
    }
    get type() {
        return UserType.Supplier;
    }
    get supplierId() {
        return this._data.supplierId;
    }
    get role() {
        return this._data.role;
    }
    get baseUrl() {
        return `${super.baseUrl}/suppliers/${this.supplierId}/users/${this.id}`;
    }
    get data() {
        const parent = super.data;
        const { supplierId, role } = this;
        const { version } = this._data;
        return { ...parent, version, supplierId, role };
    }
    get links() {
        return {
            self: `${this.baseUrl}`,
        };
    }
}
